import { render, staticRenderFns } from "./requestPodDetail.vue?vue&type=template&id=aa126dfa&scoped=true"
import script from "./requestPodDetail.vue?vue&type=script&lang=js"
export * from "./requestPodDetail.vue?vue&type=script&lang=js"
import style0 from "./requestPodDetail.vue?vue&type=style&index=0&id=aa126dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa126dfa",
  null
  
)

export default component.exports